export const environment = {
  production: false,  
  DomainURL: "https://login.htxdbscl.vn/",
  DomainDestination: "https://login.htxdbscl.vn/#/",
  CMSDomainURL: "https://cms.htxdbscl.vn/",
  CMSDomainDestination: "https://cms.htxdbscl.vn/#/",
  APIURL: "https://api.cms.htxdbscl.vn/api/v1/",    
  APIRootURL: "https://api.cms.htxdbscl.vn/",        
  InitializationString: "",  
  InitializationNumber: 0, 
  DonViToChucID: 2, 
  DuKhachID: 3, 
  NguoiDanID: 4, 
  Token: "Token",
  MembershipID: "MembershipID",  
  LoginSuccess: "Đăng nhập thành công.",
  LoginNotSuccess: "Đăng nhập không thành công.",   
  RegisterSuccess: "Đăng ký thành công.",
  RegisterNotSuccess: "Đăng ký không thành công.",  
  EmailRequired: "Email is required.", 
  EmailExists: "Email đã được đăng ký.", 
  PhoneExists: "Điện thoại đã được đăng ký.", 
  EmailNotExists: "Email chưa đăng ký.", 
  MOMOExists: "MOMO đã được đăng ký.",   
  ForgotPassword: "Mật khẩu mới đã được gửi đến email của bạn.",
};

